module.exports = __webpack_public_path__ + "static/media/card-course.db54394b.png";